import styled, { css } from 'styled-components';

import UI from '../../common/UI';

const Logo = styled(UI.Link)`
  ${({ theme }) => css`
    display: inline-block;

    @media ${theme.devices.sm} {
      padding-top: ${(theme.navBarHeight.md - 12) / 2}px;
      padding-bottom: ${(theme.navBarHeight.md - 12) / 2}px;

      img {
        height: 12px;
        display: block;
      }
    }

    @media ${theme.devices.md} {
      padding-top: ${(theme.navBarHeight.md - 14) / 2}px;
      padding-bottom: ${(theme.navBarHeight.md - 14) / 2}px;

      img {
        height: 14px;
        display: block;
      }
    }
  `}
`;

export default Logo;
